import store from "../reducers";
import en from "./en";
import es from "./es";
import it from "./it";
import itRebranding from "./itRebranding";
import enRebranding from "./enRebranding";
import esRebranding from "./esRebranding";

const getNavigatorLanguage = () => navigator.language || navigator.userLanguage;
const getUserLocale = () => store.getState().auth.loginAuth.locale || getNavigatorLanguage();

/**
 * Given the user's locale, returns the appropriate translated messages.
 * If the provided locale has no matching translations, defaults to italian.
 * @param {string} locale The user's locale expressed as an ISO language code (ex: it, it-IT, en-US)
 * @param {boolean} isRebrandingEnabled Whether to use rebranding translations
 */

function getMessagesFromLocale(locale = getUserLocale(), isRebrandingEnabled = false) {
    const availableLocalisations = {
        en: isRebrandingEnabled ? enRebranding : en,
        es: isRebrandingEnabled ? esRebranding : es,
        it: isRebrandingEnabled ? itRebranding : it
    };
    if (locale) {
        const availableLocaleKeys = Object.keys(availableLocalisations);

        if (availableLocaleKeys.includes(locale)) {
            return availableLocalisations[locale];
        } else if (availableLocaleKeys.includes(locale.split("-")[0])) {
            return availableLocalisations[locale.split("-")[0]];
        }
    }

    return availableLocalisations["it"];
}

const translateMessage = key => getMessagesFromLocale()[key] || key;
const translateMessageWithParams = (key, values) => {
    let msg = getMessagesFromLocale()[key] || key;

    Object.keys(values).forEach(valueKey => {
        msg = msg.replace(`{${valueKey}}`, values[valueKey]);
    });

    return msg;
};

export { getMessagesFromLocale, translateMessage, translateMessageWithParams };
